





































































































import Vue from 'vue';
import HeaderFilters from './HeaderFilters.vue';
import MStoreColumnSort from './MStoreColumnSort.vue';
import { Fullscreen } from '@/utils';
import { ComponentHelper } from '@/mixins/componentHelper';
import { FilterDefaults } from '@/types/constants/TableConstants';

export default Vue.extend({
  name: 'Header',
  components: {
    HeaderFilters,
    MStoreColumnSort
  },
  mixins: [ComponentHelper],
  props: {
    size: {
      type: String
    },
    headerText: {
      type: String,
      required: true
    },
    hasError: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    showHideFilters: {
      type: Boolean,
      default: false
    },
    allowWallboardMode: {
      type: Boolean,
      default: false
    },
    wallboardRefreshIntervalInSeconds: {
      type: Number,
      default: 0
    },
    emitFilters: {
      type: Boolean,
      default: false
    },
    showFilters: {
      type: Boolean,
      default: false
    },
    searchQuery: {
      type: [String, Array],
      default: ''
    },
    slideDuration: {
      type: Number,
      default: 1000
    },
    wallboardElement: {
      type: Element,
      required: false
    },
    showItemsPerPage: {
      type: Boolean,
      default: true
    },
    isWallboardMode: {
      type: Boolean,
      default: false
    },
    filteringEnabled: {
      type: Boolean,
      default: true
    },
    pinFilter: Boolean,
    exportToCsvVisible: {
      type: Boolean,
      required: false,
      default: false
    },
    exportToCsvEnabled: {
      type: Boolean,
      required: false,
      default: false
    },
    debounce: {
      type: Number
    },
    refreshButtonVisible: {
      type: Boolean,
      default: true
    },
    fields: {
      type: Array,
      required: false
    },
    sortOptions: {
      type: Array,
      required: false
    },
    enableCustomSorting: {
      type: Boolean,
      default: false
    },
    pinSort: {
      type: Boolean,
      default: false
    },
    filteringSortingExcludedColumns: {
      type: Array,
      default: () => []
    },
    showSorting: {
      type: Boolean,
      default: false
    },
    canPinSortingAndFiltering: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      internalShowFilters: true,
      internalSearchQuery: '',
      supportsFullscreen: false,
      isFullscreen: false,
      wallboardRefreshInterval: null
    };
  },
  methods: {
    onToggleWallboardMode(this: any) {
      const elementToFullscreen = this.wallboardElement ? this.wallboardElement : this.$el.parentElement;
      Fullscreen.toggleFullscreen(elementToFullscreen);
    },
    handleWallboardRefresh(this: any) {
      if (this.wallboardRefreshInterval) {
        clearInterval(this.wallboardRefreshInterval);
        this.wallboardRefreshInterval = null;
      }

      if (this.wallboardRefreshIntervalInSeconds > 0 && this.isFullscreen) {
        const timeout = this.wallboardRefreshIntervalInSeconds * 1000;

        this.wallboardRefreshInterval = setInterval(() => {
          this.$emit('refresh-triggered');
        }, timeout);
      }
    },
    handleOnFullscreenChange(this: any) {
      this.isFullscreen = Fullscreen.isFullscreen();
      this.handleWallboardRefresh();
      this.$emit('update:is-wallboard-mode', this.isFullscreen);
    },
    onPinFilterClick(this: any) {
      if (this.pinFilter) {
        this.$emit('update:show-filters', true);
      }
      this.$emit('update:pin-filter', !this.pinFilter);
    },
    onShowHideFilterClick(this: any) {
      this.localShowFilters = !this.slideUpDownActive;
      if (!this.localShowFilters) {
        this.focusElementById(FilterDefaults.ElementId);
      }
    },
    async onShowHideSortingClick(this: any) {
      this.$emit('update:show-sorting', !this.showSorting);
      await Vue.nextTick();
      if (!this.showSorting) {
        this.$emit('update:pin-sort', false);
      }
    },
    onPinSortClick(this: any) {
      if (this.pinSort) {
        this.$emit('update:show-sorting', true);
      }
      this.$emit('update:pin-sort', !this.pinSort);
    }
  },
  computed: {
    localShowFilters: {
      get(this: any): boolean {
        return this.emitFilters ? this.showFilters : this.internalShowFilters;
      },
      set(this: any, value: any) {
        if (this.emitFilters) {
          this.$emit('update:show-filters', value);
        } else {
          this.internalShowFilters = value;
        }
        if (value === false) {
          this.$emit('update:pin-filter', value);
        }
      }
    },
    localSearchQuery: {
      get(this: any): string {
        return this.emitFilters ? this.searchQuery : this.internalSearchQuery;
      },
      set(this: any, value: any) {
        if (this.emitFilters) {
          this.$emit('update:search-query', value);
        } else {
          this.internalSearchQuery = value;
        }
      }
    },
    supportsWallboardMode: {
      get(this: any): boolean {
        return this.allowWallboardMode && this.supportsFullscreen;
      }
    },
    slideUpDownActive(this: any) {
      return this.localShowFilters || this.pinFilter;
    },
    sortSlideUpDownActive(this: any) {
      return this.showSorting || this.pinSort;
    },
    filteringSortingFields(this: any) {
      return this.fields.filter((x: any) => !this.filteringSortingExcludedColumns.includes(x.key));
    }
  },
  created() {
    if (this.pinSort) {
      this.$emit('update:show-sorting', true);
    }

    this.supportsFullscreen = Fullscreen.supportsFullscreen();

    Fullscreen.registerFullscreenChange(this.handleOnFullscreenChange);
  },
  beforeDestroy() {
    Fullscreen.removeFullscreenChange(this.handleOnFullscreenChange);
  },
  watch: {
    wallboardRefreshIntervalInSeconds(this: any) {
      this.handleWallboardRefresh();
    }
  }
});
